export enum PartnerRoleTypeEnum {
    PARTNER = 'Partner',
    CONSULTANT = 'Consultant',
    REPRESENTATIVE = 'Representative',
    COUNTER = 'Counter',
    UNIT = 'Unit',
    SUPPLIER = 'Supplier',
    UNKNOWN = 'Unknown'
  }